export default {
  verifying: 'Verificando email...'
}
